module.exports = __webpack_public_path__ + "img/shopIcon16.93cd4f71.png";